import { createEmptyLogsAndVars, dwReportError, recordVariable } from "../diagnostics/clientErrors";
export const toFeedbackJson = (data) => {
    const json = JSON.stringify(data);
    return json;
};
export const fromFeedbackJson = (json) => {
    try {
        return JSON.parse(json);
    }
    catch (ex) {
        const logsAndVars = createEmptyLogsAndVars("feedbackJsonConvert:fromFeedbackJson");
        recordVariable(logsAndVars, "json (param)", json);
        dwReportError(null, undefined, ex, { logsAndVars });
        return undefined;
    }
};
export const createStorageJson = (address, 
//from_email: string,
date, 
//browser: string,
//webpage: string,
cleanMessage_1, 
//cleanMessage_2: string,
//cleanMessage_3: string,
//question_1: BigInteger,
//question_2: BigInteger,
//question_3: BigInteger,
//question_4: BigInteger,
//question_5: BigInteger,
//question_6: BigInteger,
//question_7: BigInteger,
//question_8: BigInteger,
//question_9: BigInteger,
//question_10: BigInteger,
isUnread) => {
    const profileData = {
        address: address,
        feedback: {
            //from_email: from_email,
            date: date,
            //browser: browser,
            //webpage: webpage,
            cleanMessage_1: cleanMessage_1,
            //cleanMessage_2: cleanMessage_2,
            //cleanMessage_3: cleanMessage_3,
            //question_1: question_1,
            //question_2: question_2,
            //question_3: question_3,
            //question_4: question_4,
            //question_5: question_5,
            //question_6: question_6,
            //question_7: question_7,
            //question_8: question_8,
            //question_9: question_9,
            //question_10: question_10,
            isUnread: isUnread,
        },
    };
    return profileData;
};
